/**
 * @constructor
 */
const SearchContext = function () {
    /**
     * @type {Order|null}
     */
    this.currentOrder = null;

    /**
     * @type {ItemInstance|null}
     */
    this.itemInstance = null;

    /**
     * @type {?OrderLine}
     */
    this.orderItem = null;
};

SearchContext.prototype = {};

module.exports = SearchContext;
